<template>
  <div class="confirm-wrapper">
    <div class="confirm-form">
      <div class="image-container">
        <img src="/icons/qr-grey-logo.svg" class="confirm-form-logo" alt="QRWaiter Logo" />
        <br />
        <div class="text-center" v-if="!success && !error">{{ $t('confirm_register.text' )}}</div>
      </div>
      <div class="error-block text-center" v-if="error">
        {{ $t('confirm_register.error')}}
        <br />
        {{ $t(`confirm_register.init_errors.${error}`) }}
      </div>
      <div class="confirm-form-container" v-if="!error">
        <form @submit.prevent="onFormSubmit" v-if="!success">
          {{ $t('confirm_register.password') }}
          <div class="password-container">
            <input
              class="confirm-form-input"
              @focus="onPasswordFocus"
              type="password"
              v-model="form.password"
              required
            />
            <div class="password-requirements c-white" v-if="form.password">
              {{ $t('confirm_register.pass_strength.title')}}:
              <span
                class="c-red"
                v-if="password_score == 0"
              >{{ $t('confirm_register.pass_strength.0')}}</span>
              <span
                class="c-red"
                v-if="password_score == 1"
              >{{ $t('confirm_register.pass_strength.1')}}</span>
              <span
                class="c-yellow"
                v-if="password_score == 2"
              >{{ $t('confirm_register.pass_strength.2')}}</span>
              <span
                class="c-green"
                v-if="password_score == 3"
              >{{ $t('confirm_register.pass_strength.3')}}</span>
              <span
                class="c-green"
                v-if="password_score == 4"
              >{{ $t('confirm_register.pass_strength.4')}}</span>
            </div>
          </div>
          {{ $t('confirm_register.repeat_password') }}
          <br />
          <input class="confirm-form-input" type="password" v-model="form.repeat" required />
          <br />
          <button
            class="confirm-form-submit"
            type="submit"
            :disabled="busy"
          >{{ $t('confirm_register.continue') }}</button>
        </form>
        <div class="success-block c-lightgreen" v-if="success">{{ $t('confirm_register.success') }}</div>
        <div class="confirm-error text-center c-red" v-if="confirm_error">{{ confirm_error }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import JoinAPI from "@/api/join";

import zxcvbn from "zxcvbn";

export default {
  data() {
    return {
      form: {
        password: "",
        repeat: ""
      },
      app_key: null,
      error: null,
      busy: false,
      success: false,
      application: null,

      password_focused: false,
      confirm_error: null
    };
  },
  methods: {
    check() {
      JoinAPI.checkApplication(this.app_key)
        .then(data => {
          this.application = data.application;
          this.error = null;
        })
        .catch(error => {
          this.error = error;
        });
    },
    onPasswordFocus() {
      this.password_focused = true;
    },
    onFormSubmit() {
      this.confirm_error = null;
      if (this.password_score < 2) {
        this.confirm_error = this.$t("confirm_register.errors.weak");
        return;
      }

      if (this.form.password != this.form.repeat) {
        this.confirm_error = this.$t("confirm_register.errors.mismatch");
        return;
      }

      this.busy = true;
      JoinAPI.confirmApplication(this.app_key, this.form.password)
        .then(ok => {
          this.success = true;
          this.autoLogin();
        })
        .catch(error => {
          this.error = error;
        });
    },
    autoLogin() {
      const vm = this;
      this.$store
        .dispatch("login", {
          email: this.application.email,
          password: this.form.password
        })
        .then(ok => {
          this.$store.commit('setMarketplaceEnabled', false);
          setTimeout(() => {
            this.$router.push("/general");
          }, 1500);
        })
        .catch(error => {
          this.$router.push('/login');
        });
    }
  },
  computed: {
    password_score() {
      if (!this.form.password) return 0;
      return zxcvbn(this.form.password).score;
    }
  },
  mounted() {
    window.location.href = `https://qrwaiter.com.ua/confirm_registration/${this.$route.params.key}`;
    // this.app_key = this.$route.params.key;
    // this.check();
  }
};
</script>

<style scoped>
.confirm-wrapper {
  width: 100vw;
  height: 100vh;
  background: #464646;

  color: white;
  text-align: center;
}

.confirm-form {
  text-align: left;

  padding-top: 12%;
  font-size: 2.2vh;
  width: 50vw;
  margin: auto;
}

.confirm-form-logo {
  width: 8vw;
  height: auto;
  margin-bottom: 2vh;
  text-align: center;
}

.confirm-form input {
  -webkit-appearance: none;
  margin: 5px;
  border-radius: 1vw;
  outline: none;
  border: 2px solid transparent;
  padding: 0.4vw 1.5vw;
  width: 100%;
}

.confirm-form-submit {
  border: 0;
  border-radius: 15px;
  outline: none;
  color: white;
  background-color: #129b81;
  padding: 15px 25px 15px 25px;
  margin-top: 15px;
  width: 100%;
  cursor: pointer;
}

.red-input {
  border: 2px solid #e2223b !important;
}

.error-block {
  color: #e2223b;
  padding: 10px 15px 10px 15px;
  border-radius: 5px;
  /* background: white; */
  /* width: 25%; */
}

.success-block {
  color: #129b81;
  text-align: center;
}

.password-container {
  position: relative;
}

.password-requirements {
  font-size: 1.7vh;
  color: #a4a3a1;
  transition: 0.2s;
  text-align: left;
  margin-bottom: 2vh;
}

.confirm-error {
  margin-top: 1vh;
}

.image-container {
  text-align: center;
}

.confirm-form-container {
  margin-top: 2.5vh;
}
</style>
